import React, { useState, forwardRef, useEffect, useRef } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { ReactComponent as Bingo } from '@/views/account/assets/icons/bingo.svg';
import TabsRender from './children/TabsRender';
import utils from '../../../../../../../../utils/utils';
const HistoryTabsRender = forwardRef((props, videoRef) => {
  const [select, setSelect] = useState(0);
  const tabList = props.tabList;
  const activeType = props.activeType;
  const { t } = useTranslation('upgradePersonal');
  const changeSelect = (value) => {
    setSelect(value);
    props.changeSunType(value);
  };
  // const activeSubType = props.activeSubType;
  return Object.keys(tabList).length >= 1 ? (
    <div className='histTabsBox'>
      <div className='histTabs'>
        {Object.keys(tabList).map((item, index) => (
          <TabsRender
            key={'tab' + index}
            item={item}
            activeType={activeType}
            changeType={props.changeType}
          />
        ))}
      </div>
      <div
        className='rightFilter'
        onClick={(e) => {
          e.stopPropagation();
          props.changeFilter();
        }}
      >
        <div className='created'>{t('Modified')}</div>
        <div
          className={`filterListBox ${
            utils.getLanguage() === 'ar' ? 'isAr' : 'NotAr'
          }`}
        >
          <div className={`filterList ${props.isShowFilter ? 'active' : ''}`}>
            <div className='selectContainer'>
              <div className='orderTitle'>{t('Order')}</div>
              <div
                className='selectList'
                onClick={() => {
                  changeSelect(1);
                }}
              >
                {select === 1 ? (
                  <Bingo />
                ) : (
                  <span
                    style={{
                      display: 'inline-block',
                      width: 20,
                      height: 20,
                    }}
                  ></span>
                )}{' '}
                {t('EarliestToLatest')}
              </div>
              <div
                className='selectList'
                onClick={() => {
                  changeSelect(0);
                }}
              >
                {select === 0 ? (
                  <Bingo />
                ) : (
                  <span
                    style={{
                      width: 20,
                      height: 20,
                    }}
                  ></span>
                )}
                {t('LatestToEarliest')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ''
  );
});

export default HistoryTabsRender;
